export class ExceptionCodesConstant {

  //#region Properties

  public static readonly channelNotFound = 'CHANNEL_NOT_FOUND';

  //#endregion

}
